var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'dp-circle-loader',
    {
      'dp-circle-loader--small': _vm.size === 'small',
      'dp-circle-loader--white': _vm.white,
      'dp-circle-loader--left-aligned': _vm.leftAligned,
    } ]},[_c('div',{staticClass:"bounce1"}),_c('div',{staticClass:"bounce2"}),_c('div',{staticClass:"bounce3"})])}
var staticRenderFns = []

export { render, staticRenderFns }